import { Tooltip, Typography } from '@mui/material'
import { CustomVariableValue } from '@/types/custom-variables'

type VariableValueDisplayProps = {
  variableValue?: CustomVariableValue
  resolvedValue: string | null
  isInheriting?: boolean
}

export default function VariableValueDisplay({
  variableValue,
  resolvedValue,
  isInheriting,
}: VariableValueDisplayProps) {
  const displayedValue = variableValue?.value || resolvedValue
  return (
    <Typography
      color={!variableValue ? 'text.secondary' : undefined}
      sx={{ wordBreak: 'break-word' }}
    >
      {isInheriting ? (
        <Tooltip title="Value inherited from a parent organization">
          <i>{displayedValue}</i>
        </Tooltip>
      ) : (
        displayedValue
      )}
    </Typography>
  )
}
